module.exports = __webpack_public_path__ + "765c860c7d6959b77c56387422f08f84.pdf";